import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  padding: 0;\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", " \n  ", "\n  ", "\n\n  & > li {\n    ", "\n    ", "\n    ", "\n  }\n  & > li::before {\n    content: '\\2022';\n    color: ", ";\n    margin: 0 8px 0 2px;\n    ", "\n    ", "\n  }\n  & > li > ul,\n  & > li > ol {\n    padding-left: 32px;\n    ", "\n  }\n  ", "\n"], ["\n  list-style: none;\n  padding: 0;\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", " \n  ", "\n  ", "\n\n  & > li {\n    ", "\n    ", "\n    ", "\n  }\n  & > li::before {\n    content: '\\\\2022';\n    color: ", ";\n    margin: 0 8px 0 2px;\n    ", "\n    ", "\n  }\n  & > li > ul,\n  & > li > ol {\n    padding-left: 32px;\n    ", "\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { ADVENTURE_GREEN } from '../colors';
import { fontSpacingKeys, fontSpacingMixin } from '../mixins/typography';
import { getPx } from '../helpers/common';
import { LIST_INLINE_HORIZONTAL_OFFSET, LIST_INLINE_VERTICAL_OFFSET } from '../List/constants';
import { withOmitProps } from '../helpers/elements';
import { Base as BaseSpacing } from './constants/base.spacing';
import { isDefined } from '../helpers/defined';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../helpers/media-style';
import { textAlign } from '../style/text-align';
import { paddingHalfVertical } from '../style/padding-vertical';
import { marginVerticalHalfNegative } from '../style/margin-vertical-negative';
var UL_VERTICAL_SPACING = 2;
var Ul = styled.ul.withConfig(withOmitProps(['withIcons', 'listStyleNone', 'inline', 'expanded', 'noWrap', 'horizontalOffset', 'verticalOffset', 'textAlignCenter', 'textAlignLeft', 'textAlignRight', 'textAlign'].concat(fontSpacingKeys)))(_templateObject(), marginVerticalHalfNegative(UL_VERTICAL_SPACING), function (_ref) {
  var value = _ref.textAlign;
  return isDefined(value) ? textAlign(value) : '';
}, function (_ref2) {
  var textAlignCenter = _ref2.textAlignCenter;
  return textAlignCenter ? "text-align: center;" : '';
}, function (_ref3) {
  var textAlignLeft = _ref3.textAlignLeft;
  return textAlignLeft ? "text-align: left;" : '';
}, function (_ref4) {
  var textAlignRight = _ref4.textAlignRight;
  return textAlignRight ? "text-align: right;" : '';
}, function (_ref5) {
  var inline = _ref5.inline,
      horizontalOffset = _ref5.horizontalOffset;
  return styleArrayForBreakpoints([inline, horizontalOffset != null ? horizontalOffset : LIST_INLINE_HORIZONTAL_OFFSET], function (_ref6) {
    var inline = _ref6[0],
        horizontalOffset = _ref6[1];
    return inline ? "\n            margin-left: calc(-" + getPx(horizontalOffset) + " / 2);\n            margin-right: calc(-" + getPx(horizontalOffset) + " / 2);\n          " : '';
  });
}, function (_ref7) {
  var expanded = _ref7.expanded,
      verticalOffset = _ref7.verticalOffset;
  return styleArrayForBreakpoints([expanded, verticalOffset != null ? verticalOffset : LIST_INLINE_VERTICAL_OFFSET], function (_ref8) {
    var expanded = _ref8[0],
        verticalOffset = _ref8[1];
    return expanded ? "\n            margin-top: calc(-" + getPx(verticalOffset) + " / 2);\n            margin-bottom: calc(-" + getPx(verticalOffset) + " / 2);\n          " : '';
  });
}, function (_ref9) {
  var inline = _ref9.inline,
      noWrap = _ref9.noWrap;
  return styleForBreakpoints(inline, function (inline) {
    return inline && noWrap ? "white-space: nowrap;" : '';
  });
}, paddingHalfVertical(UL_VERTICAL_SPACING), function (_ref10) {
  var inline = _ref10.inline,
      horizontalOffset = _ref10.horizontalOffset;
  return styleArrayForBreakpoints([inline, horizontalOffset != null ? horizontalOffset : LIST_INLINE_HORIZONTAL_OFFSET], function (_ref11) {
    var inline = _ref11[0],
        horizontalOffset = _ref11[1];
    return inline ? "\n              display: inline-flex;\n              flex-direction: column;\n              align-items: flex-start;\n              justify-content: center;\n              box-sizing: border-box;\n              vertical-align: middle;\n              padding-left: calc(" + getPx(horizontalOffset) + " / 2);\n              padding-right: calc(" + getPx(horizontalOffset) + " / 2);\n            " : '';
  });
}, function (_ref12) {
  var expanded = _ref12.expanded,
      verticalOffset = _ref12.verticalOffset;
  return styleArrayForBreakpoints([expanded, verticalOffset != null ? verticalOffset : LIST_INLINE_VERTICAL_OFFSET], function (_ref13) {
    var expanded = _ref13[0],
        verticalOffset = _ref13[1];
    return expanded ? "\n              margin-bottom: 0;\n              padding-top: calc(" + getPx(verticalOffset) + " / 2);\n              padding-bottom: calc(" + getPx(verticalOffset) + " / 2);\n            " : '';
  });
}, ADVENTURE_GREEN, function (_ref14) {
  var listStyleNone = _ref14.listStyleNone,
      inline = _ref14.inline;
  return styleForBreakpoints(inline, function (inline) {
    return inline || listStyleNone ? "\n            content: none;\n            margin: 0;\n          " : '';
  });
}, function (_ref15) {
  var withIcons = _ref15.withIcons;
  return withIcons ? "\n          content: '';\n          width: 0;\n          margin: 0;\n        " : '';
}, function (_ref16) {
  var listStyleNone = _ref16.listStyleNone,
      inline = _ref16.inline;
  return styleForBreakpoints(inline, function (inline) {
    return inline || listStyleNone ? "padding-left: 0;" : '';
  });
}, fontSpacingMixin(BaseSpacing));
export default Ul;